module.exports = __webpack_public_path__ + "static/media/weather.82f6e457.png";